var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1220_22653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.58 14.146l-2.322-2.323a.726.726 0 00-.522-.213.708.708 0 00-.532.213.718.718 0 00-.217.527c0 .206.072.382.217.527l2.744 2.744c.18.18.392.271.633.271.24 0 .452-.09.633-.27l5.563-5.564a.726.726 0 00.212-.522.708.708 0 00-.212-.532.718.718 0 00-.527-.217.718.718 0 00-.527.217l-5.142 5.142zm1.422 7.354a9.254 9.254 0 01-3.706-.748 9.596 9.596 0 01-3.016-2.03 9.595 9.595 0 01-2.032-3.016 9.246 9.246 0 01-.748-3.704c0-1.314.25-2.55.748-3.706a9.596 9.596 0 012.03-3.016 9.594 9.594 0 013.016-2.032 9.246 9.246 0 013.704-.748c1.314 0 2.55.25 3.706.748a9.596 9.596 0 013.017 2.03 9.594 9.594 0 012.03 3.016 9.247 9.247 0 01.749 3.704c0 1.314-.25 2.55-.748 3.706a9.596 9.596 0 01-2.03 3.017 9.595 9.595 0 01-3.016 2.03 9.247 9.247 0 01-3.704.749z",
    fill: "currentColor"
  }))));
}
SvgSuccessFilled.displayName = 'SuccessFilled';
export default SvgSuccessFilled;